var exports = {
  "W": "x52a3aa3b--7b3f04--dropdown",
};

module.exports = exports;
